var map = {
	"./bad.svg": "./src/assets/roomType/lms/img/emoti-img/bad.svg",
	"./clap.svg": "./src/assets/roomType/lms/img/emoti-img/clap.svg",
	"./emoti-angry.svg": "./src/assets/roomType/lms/img/emoti-img/emoti-angry.svg",
	"./emoti-crying.svg": "./src/assets/roomType/lms/img/emoti-img/emoti-crying.svg",
	"./emoti-fall-love.svg": "./src/assets/roomType/lms/img/emoti-img/emoti-fall-love.svg",
	"./emoti-laugh.svg": "./src/assets/roomType/lms/img/emoti-img/emoti-laugh.svg",
	"./emoti-panic.svg": "./src/assets/roomType/lms/img/emoti-img/emoti-panic.svg",
	"./emoti-ruined.svg": "./src/assets/roomType/lms/img/emoti-img/emoti-ruined.svg",
	"./emoti-satisfaction.svg": "./src/assets/roomType/lms/img/emoti-img/emoti-satisfaction.svg",
	"./emoti-show-off.svg": "./src/assets/roomType/lms/img/emoti-img/emoti-show-off.svg",
	"./emoti-smile.svg": "./src/assets/roomType/lms/img/emoti-img/emoti-smile.svg",
	"./emoti-star.svg": "./src/assets/roomType/lms/img/emoti-img/emoti-star.svg",
	"./emoti-surprise.svg": "./src/assets/roomType/lms/img/emoti-img/emoti-surprise.svg",
	"./emoti-tears.svg": "./src/assets/roomType/lms/img/emoti-img/emoti-tears.svg",
	"./emoti-tease-ya.svg": "./src/assets/roomType/lms/img/emoti-img/emoti-tease-ya.svg",
	"./emoti-thumbs-up.svg": "./src/assets/roomType/lms/img/emoti-img/emoti-thumbs-up.svg",
	"./emoti-wink.svg": "./src/assets/roomType/lms/img/emoti-img/emoti-wink.svg",
	"./good.svg": "./src/assets/roomType/lms/img/emoti-img/good.svg",
	"./grm-face-01.svg": "./src/assets/roomType/lms/img/emoti-img/grm-face-01.svg",
	"./hand.svg": "./src/assets/roomType/lms/img/emoti-img/hand.svg",
	"./o.svg": "./src/assets/roomType/lms/img/emoti-img/o.svg",
	"./slowly.svg": "./src/assets/roomType/lms/img/emoti-img/slowly.svg",
	"./wonder.svg": "./src/assets/roomType/lms/img/emoti-img/wonder.svg",
	"./x.svg": "./src/assets/roomType/lms/img/emoti-img/x.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/roomType/lms/img/emoti-img sync recursive ^\\.\\/.*\\.svg$";